import { StyledTab, StyledTabList, StyledTabPanel, StyledTabs } from "./styled"

export { TabContext } from "@mui/lab"

export const Tab = StyledTab
export const TabList = StyledTabList
export const Tabs = StyledTabs
export const TabPanel = StyledTabPanel
